exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-2e0a7bcc]{color:#e31837;font-weight:700}", ""]);

// exports
